import { QueryClient } from "react-query";

import { TokenExpiredError } from "@/shared/errors";

const useErrorBoundary = (error: any) => !(error instanceof TokenExpiredError);

const queryClient = new QueryClient({
    defaultOptions: {
        mutations: {
            useErrorBoundary,
        },
        queries: {
            retry: false,
            suspense: true,
            useErrorBoundary,
            staleTime: 5 * 60 * 1000 /* 5 min */,
        },
    },
});

export default queryClient;
